<script setup>
  import { computed } from 'vue';
  import { useUserStore } from '@/stores/UserStore';
  import { useMediaQuery } from '@/composables/useMediaQuery';
  import FavoriteSpotUserTip from "@/components/FavoriteSpotUserTip.vue";
  import Popup from '@/components/controls/Popup.vue';
  import Icon from '@/components/icons/Icon.vue';
  import useSettingsGlobals from '@/composables/useSettingsGlobals';

  const { $WEB_VIEW } = useSettingsGlobals();  

  const props = defineProps({
    showFavoritesUserTip: {
      type: Boolean,
      default: true
    }
  });

  const userStore = useUserStore();

  const isDesktop = useMediaQuery('(min-width: 840px)');
  const isSmallDevice = useMediaQuery('(max-width: 539px)');

  const showUserTip = computed(() => userStore.memberLevel > 0 && !isSmallDevice.value && !isDesktop.value && !$WEB_VIEW && props.showFavoritesUserTip);
</script>

<template>
  <Popup
    id="spot-header-jwx-action-menu"
    positionY="bottom"
    class="jwx-page-header__actions"
  >
    <template #button-content>
      <div class="jwx-popup__button">
        <Icon name="more-menu" class="jwx-user-favorite__menu-icon" />
        <span class='sr-only'>Open Spot Action Menu</span>
      </div>
    </template>
    
    <template #menu-content>
      <div class="jwx-popup-menu">
        <slot name="menu-content"></slot>
      </div>
    </template>
    <template #misc>
      <FavoriteSpotUserTip
        v-if="showUserTip"
        :menu="true"
        alignment="right"
      />
    </template>
  </Popup>      
</template>